var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer-component"},[_c('span',{staticClass:"time",class:_vm.minutes <= 1 ? 'red' : null},[_vm._v(_vm._s(_vm.hoursString)+":"+_vm._s(_vm.minutesString)+":"+_vm._s(_vm.secondsString))])])}
var staticRenderFns = []

export { render, staticRenderFns }